export default __webpack_public_path__ + "static/media/OthersPmtPrev.3e755d2f.jpeg";